import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaBars, FaTimes, FaHeart } from "react-icons/fa";
import { FcCancel } from "react-icons/fc";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaRegSmileWink } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import LoginModal from "./LoginModal";
import DonatieModal from "./DonatieModal";
import logo from "../assests/logo.png";
import './Navbar.css'

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showDonatieModal, setShowDonatieModal] = useState(false);
  const [pendingRoute, setPendingRoute] = useState(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleProtectedClick = (route) => {
    setIsOpen(false);
    if (user) {
      navigate(route);
    } else {
      setPendingRoute(route);
      setShowLoginModal(true);
    }
  };

  const handleModalClose = () => {
    setShowLoginModal(false);
    setPendingRoute(null);
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-logo">
          <Link to="/">
            <img className="logo" src={logo} alt="FindMyPet Logo" />
          </Link>
          <h1 className="hero-title">Find my pet</h1>
        </div>

        <ul className={`nav-links ${isOpen ? "nav-active" : ""}`}>
          <li>
            <Link to="/animale-gasite" onClick={() => setIsOpen(false)}>
              Animale găsite
            </Link>
            <IoMdCheckmarkCircleOutline style={{ color: "green" }} />
          </li>
          <li>
            <Link to="/animale-pierdute" onClick={() => setIsOpen(false)}>
              Animale pierdute
            </Link>
            <FcCancel />
          </li>
          <li>
            <Link to="/succese-findmypet" onClick={() => setIsOpen(false)}>
              Succese prin FindMyPet
            </Link>
            <FaRegSmileWink style={{ color: "purple" }} />
          </li>
          <li>
            <button
              className="nav-btn-special"
              onClick={() => handleProtectedClick("/RaporteazaAnimalutGasit")}
            >
              Am găsit un animăluț
            </button>
          </li>
          <li>
            <button
              className="nav-btn-special"
              onClick={() => handleProtectedClick("/RaporteazaAnimalutPierdut")}
            >
              Mi-am pierdut animaluțul
            </button>
          </li>
        </ul>

        <div className="navbar-menu-icon" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>
      </nav>

      {/* Banner donație rulant */}
      <div
        className="donatie-banner"
        onClick={() => setShowDonatieModal(true)}
        role="button"
        style={{ cursor: "pointer" }}
      >
        <div className="donatie-banner-scroll">
          {[...Array(4)].map((_, i) => (
            <div className="donatie-banner-segment" key={i}>
              <img src={logo} alt="logo" className="donatie-mini-logo" />
              <FaHeart className="donatie-heart-icon" />
              <span className="donatie-text-alb">Ajută animalele fără stăpân</span>
              <span className="donatie-text-gold">Donează acum</span>
              <span className="donatie-text-alb">50% merge la asociații pentru animale</span>
              <FaHeart className="donatie-heart-icon" />
            </div>
          ))}
        </div>
      </div>

      {showLoginModal && (
        <LoginModal
          onClose={handleModalClose}
          pendingRoute={pendingRoute}
        />
      )}

      {showDonatieModal && (
        <DonatieModal onClose={() => setShowDonatieModal(false)} />
      )}
    </>
  );
}